<template>
  <div class="economic-production-pavilion">
    <div class="chart-con has-tab">
      <div class="pie-bg" v-if="tabIndex"></div>
      <div class="chart-pie">
        <v-chart ref="pie3D-chart-allLevelsMembersProportion" id="pie3D-chart-allLevelsMembersProportion" class="pie3D-chart"
                 v-show="tabIndex"
                 :options="chartOption" />
        <v-chart ref="pie-chart" id="pie-chart" class="pie-chart" v-show="!tabIndex" :options="chartOption" />
        <div :class="['chart-legend', { chart3d: tabIndex }]">
          <div class="legend-list">
            <div class="legend-item" v-for="(item, i) in chartSchemaData" :key="i">
              <div class="name">
                <span class="color" :style="{ 'background-color': tabIndex ? colors3D[item.index] :
                colors[item.index] }"></span>
                <el-tooltip effect="dark" placement="top" v-if="item.name && item.name.length > 6">
                  <span>
                    {{ item.name ? item.name : '-' }}
                  </span>
                  <div slot="content">
                    {{ item.name ? item.name : '-' }}
                  </div>
                </el-tooltip>
                <span v-else>
                  {{ item.name ? item.name : '-' }}
                </span>
              </div>
              <span class="num">
                {{ item.percent }}<span class="unit">%&nbsp;&nbsp;&nbsp;</span>{{ item.value }}<span class="unit">
                位</span>

              </span>

            </div>
          </div>
          <div class="pager-box" v-if="!tabIndex">
            <i :class="['el-icon-caret-top', { dis: pager.current <= 1 }]" @click="changePage(false)"></i>
            <div>
              {{ pager.current }}
              <span> / {{ pager.total }} </span>
            </div>
            <i :class="['el-icon-caret-bottom', { dis: pager.current >= pager.total }]" @click="changePage(true)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import drawPie from '../chartJs/pie';
import drawPie3D from '../chartJs/pie3D';
import { getPieData } from '@/api/getChartData';
import TabList from '../../../components/tabList';
import echarts from 'echarts';
import ElementSelect from '../../../components/element-select';

const colors3D = ['#00c9ff', '#0078ff', '#fcf5c2','#58ecac','#ff8c60','#a280ff'];
const colors = [
  '#00c5fa',
  '#0078ff',
  '#fcf5c2',
  '#58ecac',
  '#ff8c60',
  '#a280ff',
  '#ee6566',
  '#fac959',
  '#91cd74',
  '#3aa272',
  '#aae6ff',
];
export default {
  name: 'allLevelsMembersProportion',
  components: { ElementSelect, TabList },
  props: {
    yearP: {
      type: Number,
      default: 2023,
    },
    selectListP: {
      // 列信息
      type: Array,
      default: () => {
        return [];
      },
    },
    searchData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showIndex:{
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      chartData: null,
      chartSchemaData: null,
      tabIndex: 1,

      colors,
      colors3D,
      year: this.yearP,
      selectList: [
        // {
        //   value: 2020,
        //   label: '2020',
        // },
        // {
        //   value: 2021,
        //   label: '2021',
        // },
        // {
        //   value: 2022,
        //   label: '2022',
        // },
        ...this.selectListP,
      ],
      // ],

      tabList: [
        {
          key: 0,
          label: '行业',
        },
        {
          key: 1,
          label: '产业',
        },
      ],
      pager: {
        current: 1,
        total: 2,
      },
      legendBox: null,
      chart: null,
      chartOption3D: null,
      chartOption: null,
    };
  },
  watch: {
    // tabIndex(n) {
    //   if (!n) {
    //     this.chart.off('click');
    //     this.chart.off('mouseover');
    //     this.chart.off('globalout');
    //   }
    //   this.chart = null;
    //   this.chartOption = null;
    //   this.chartOption3D = null;
    //   this.$nextTick(() => {
    //     this.getData();
    //   });
    // },
    // year(n) {
    //   this.$nextTick(() => {
    //     this.getData();
    //   });
    // },
    searchData(n) {
      this.chartData = n.slice();
      this.paintData();
    },
    showIndex(n) {
      this.tabIndex = n;
    },
    'pager.current'(n) {
      if (n) {
        let box = this.legendBox;
        let y = box.clientHeight * (n - 1);
        console.log(box.clientHeight, n, y);
        box.style.transform = `translateY(-${y > 0 ? y + 15 : y}px)`;
      }
    },
  },
  methods: {
    changePage(next) {
      let { current, total } = this.pager;
      if (next) {
        this.pager.current = current < total ? current + 1 : current;
      } else {
        this.pager.current = current > 1 ? current - 1 : current;
      }
    },
    paintData() {
      this.chart = this.tabIndex
          ? echarts.init(document.getElementById('pie3D-chart-allLevelsMembersProportion'))
          : echarts.init(document.getElementById('pie-chart'));
      this.$nextTick(() => {
        this.setInterData();
      });

    },
    getData() {
      this.chart = this.tabIndex
        ? echarts.init(document.getElementById('pie3D-chart-allLevelsMembersProportion'))
        : echarts.init(document.getElementById('pie-chart'));
      this.$api.screen
        .getGDPPrivateEconomy({
          caliber: this.tabList[this.tabIndex].label,
          year: this.year,
        })
        .then((res) => {
          let { data } = res.data;
          if (data?.length) {
            let list = data.map((item) => {
              return {
                name: item.quotaName,
                value: item.total,
              };
            });
            this.chartData = list;
            this.$nextTick(() => {
              this.setInterData();
            });
          } else {
            this.selectList = this.selectList.filter((x) => x.value !== this.year);
            this.year = this.selectList[0].value;
          }
        });

      // getPieData().then(res => {
      //   let type = this.tabList[this.tabIndex].label;
      //   let data = res.RECORDS.filter(item => {
      //     return item['类型'] === type && item['年份'] == this.year;
      //   });
      //   console.log(data, '-')
      //   let list = data.map(item => {
      //     return {
      //       name: item['指标'],
      //       value: Number(item['总数'])
      //     }
      //   });
      //   this.chartData = list;
      //   this.$nextTick(() => {
      //     this.setInterData();
      //   })
      // })
    },
    setInterData() {
      this.$nextTick(() => {
        let refName = this.tabIndex ? 'pie3D-chart-allLevelsMembersProportion' : 'pie-chart';
        this.$refs[refName].clear();

        if (this.tabIndex) {
          this.chartOption = drawPie3D(this.chartData, 0, this.chart, colors3D);
        } else {
          this.chartOption = drawPie(this.chartData);
        }
        let schemaData = [];
        for (let i = 0; i < this.chartData.length; i++) {
          if (this.chartData[i].name === '省级会员') {
            let obj = JSON.parse(JSON.stringify(this.chartData[i]));
            obj.index = i
            schemaData.push(obj)
          }
        }
        for (let i = 0; i < this.chartData.length; i++) {
          if (this.chartData[i].name === '市级会员') {
            let obj = JSON.parse(JSON.stringify(this.chartData[i]));
            obj.index = i
            schemaData.push(obj)
          }
        }
        for (let i = 0; i < this.chartData.length; i++) {
          if (this.chartData[i].name === '县级会员') {
            let obj = JSON.parse(JSON.stringify(this.chartData[i]));
            obj.index = i
            schemaData.push(obj)
          }
        }
        this.chartSchemaData = schemaData;
      });
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.getData();
    //   let box = $('.legend-list');
    //   this.legendBox = box[0];
    // });
  },
};
</script>

<style lang="less" scoped>
.economic-production-pavilion {
  .chart-box();
  height: 420px;
  width: 100%;

  /deep/ .tab-list {
    .tab-item {
      min-width: 60px !important;
    }
  }

  .chart-con {
    overflow: inherit;
  }

  .pie-bg {
    width: 490px;
    height: 198px;
    background: url('~img/home/pie-bg.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: -36px;
    bottom: -5px;
    /*z-index: 2;*/
  }

  .chart-pie {
    display: flex;
  }

  #pie-chart,
  #pie3D-chart-allLevelsMembersProportion {
    width: 465px;
    height: 380px;
    //margin-top: -20px;
    margin-top: 10px;
    padding-left: 12px;
  }

  .chart-legend {
    width: calc(100% - 245px);
    /*width: 50%;*/
    color: #fff;
    height: 350px;
    //padding-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    max-height: 350px;
    overflow: hidden;
    margin-left: -30px;
    //.show-scroll-bg-trans();

    &.chart3d {
      justify-content: center;
      max-height: 350px;

      .legend-item {
        line-height: 30px;
        //margin-bottom: 20px;
      }
    }

    .legend-list {
      padding-top: 20px;
      width: 400px;
      height: calc(100% - 20px);
      transition: all 0.3s;
    }

    .pager-box {
      position: absolute;
      right: 0;
      bottom: 10px;
      .flex-center();
      padding-right: 10px;
      font-size: 12px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #87e6ff;
      line-height: 38px;

      div {
        letter-spacing: -2px;
        margin: 0 10px;

        span {
          color: rgba(135, 230, 255, 0.3);
        }
      }

      i {
        margin-top: 2px;
        cursor: pointer;

        &.dis {
          color: rgba(135, 230, 255, 0.3);
          cursor: not-allowed;
        }
      }
    }

    .legend-item {
      .flex-center();
      //flex-direction: column;
      font-size: 23px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #dcdcdc;
      /*line-height: 20px;*/
      margin-bottom: 10px;
      width: 400px;
      align-items: flex-start;

      &:first-child {
        //margin-top: 10px;
      }

      .name {
        width: 200px;
        .flex-center();

        span:last-child {
          width: calc(100% - 21px);
          .ellipsis();
        }
      }
    }

    .color {
      width: 15px;
      height: 11px;
      margin-right: 6px;
    }

    .num {
      width: 250px;
      font-size: 25px;
      font-family: Geometr706 BlkCn BT;
      font-weight: 900;
      color: #fff;
      line-height: 30px;
      margin: 0 5px 0 20px;
      text-align: left;
    }

    .unit {
      font-size: 20px;
    }
  }
}
</style>
